import axios from "axios";
import * as Sentry from '@sentry/react';
import { getToken, getTokenHeader } from "../../../screen/auth/action";
import { getDashboardConfigUrl, getHomepageDataUrl } from "../Api";

export const getHomepageData = async (manufacturer_id = null) => {
  return new Promise(async (next) => {
    try {
      const token = await getToken();
      const params = manufacturer_id ? { manufacturer_id } : {};
      const { data } = await axios.get(getHomepageDataUrl(), {
        ...getTokenHeader(token),
        params,
      });
      return next(data);
    } catch (err) {
      Sentry.captureException(err, {
        tags: { module: 'home', flow: 'getHomepageData' },
        extra: { manufacturer_id },
      });
      return next({ error: true, message: err?.response?.data?.message || err.message });
    }
  });
};

export const getDashboardConfigData = async ({
  manufacturer_id,
}) => {
  return new Promise(async (next) => {
    try {
      const token = await getToken();
      const params = { manufacturer_id };
      const { data } = await axios.get(getDashboardConfigUrl(), {
        ...getTokenHeader(token),
        params,
      });
      return next(data);
    } catch (err) {
      Sentry.captureException(err, {
        tags: { module: 'home', flow: 'getDashboardConfigData' },
        extra: { manufacturer_id },
      });
      return next({ error: true, message: err?.message || 'Something went wrong' });
    }
  });
};
